// --- 订单管理 --- //

export default [
  {
    name: 'stadiumOrder',
    path: '/stadiumSuperviseSystem/:stadiumType/swimmingSuperviseStadium/orderManagement',
    meta: { title: '订单管理' },
    component: require('business/stadiumSuperviseSystem/orderManagement/list.vue').default
  }
];
